import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "issueHoupiaoList__content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "explain" }, "如需开发票请您与对接商务经理联系，联系方式如下：", -1)
const _hoisted_3 = { class: "explain contact" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_routeTab = _resolveComponent("routeTab")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer withRouteTab issueHoupiaoList" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_routeTab),
        _createElementVNode("div", null, [
          _hoisted_2,
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.invoiceOption.name) + " " + _toDisplayString(_ctx.invoiceOption.phone), 1)
        ])
      ])
    ]),
    _: 1
  }))
}